import { notification, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { editScreening, editTestgroup } from '../../../API/services/screeningService';
import EditPen from '../../../assets/screening/EditPen';
import GenericToggle from '../../../components/GenericToggle/GenericToggle';
import { t } from '../../../i18n/i18n';
import useTranslations from '../../../hooks/useTranslations';
import './ListItem.scss';
import NumberPill from '../NumberPill/NumberPill';
import CountryFlag from '../../../components/CountryFlag/CountryFlag';
import TranslateIcon from '../../../assets/screening/TranslateIcon';
import { CATEGORY_TYPES } from '../../../constants/enums';
import { FaGlobeAmericas } from 'react-icons/fa';
import { BarChartOutlined } from '@ant-design/icons';
import TestGroupMetricsDetail from '../../../components/TestGroupMetricsDetail/TestGroupMetricsDetail';

// todo - modificar API para que devuelva enabled en ambos casos
const ListItem = ({
  id,
  name,
  nameTranslated,
  enabled,
  isEnabled,
  levelTag,
  categoryTag,
  isTestgroup,
  metrics,
  languages,
  translationEnabled,
  showTranslateModal,
  testGroupLanguageList,
  category,
}) => {
  const { key: langKey } = useTranslations();
  const [itemEnabled, setItemEnabled] = useState(enabled ?? isEnabled);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [showMetricsModal, setShowMetricsModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setItemEnabled(enabled ?? isEnabled);
  }, [enabled, isEnabled]);

  const changeTestgroupVisibility = () => {
    if (!fetchLoading) {
      setFetchLoading(true);
      setItemEnabled((state) => !state);
      if (isTestgroup) {
        editTestgroup({
          enabled: !itemEnabled,
          id,
        }).catch(() => {
          notification.open({
            message: t('ABM_TOGGLE_ITEM_ERROR').replace('{name}', nameTranslated?.[langKey] || name),
            type: 'error',
            duration: 3,
          });
        });
      } else {
        editScreening(id, {
          isEnabled: !itemEnabled,
        }).catch(() => {
          notification.open({
            message: t('ABM_TOGGLE_ITEM_ERROR').replace('{name}', nameTranslated?.[langKey] || name),
            type: 'error',
            duration: 3,
          });
        });
      }
      setFetchLoading(false);
    }
  };

  return (
    <div className="abm-list-item-container b-radius-8 bg-white border-blue-principal">
      <span className="abm-list-item-name pr-3 text-truncate  font-weight-600 text-xs my-auto h-fit">
        {nameTranslated?.[langKey] || name}
      </span>
      <div className="abm-list-item-filters-container d-flex">
        {isTestgroup && (
          <>
            <span className="mx-4 abm-list-pill d-flex">
              {CATEGORY_TYPES.LANGUAGE === category?.type ? (
                <FaGlobeAmericas color="black" size={20} className="mr-2" />
              ) : (
                (languages ?? ['UNKNOWN'])?.map((lang) => (
                  <CountryFlag
                    countryIso={testGroupLanguageList?.find((y) => y.value === lang)?.iso}
                    size="sm"
                    className="mx-1"
                  />
                ))
              )}
            </span>
            <NumberPill number={metrics?.median} className="mx-2 abm-list-pill" />
            <NumberPill number={metrics?.average} className="mx-2 abm-list-pill" />
            {metrics && (
              <button
                className="bg-transparent border-0 outline-none mx-1"
                onClick={() => setShowMetricsModal(true)}
                type="button"
                title={t('VIEW_DETAILED_METRICS')}
              >
                <BarChartOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
              </button>
            )}
          </>
        )}

        <div className="d-flex justify-content-end mx-2 abm-list-tags-container">
          {Boolean(categoryTag) && (
            <div
              className="abm-list-item-category  font-weight-700 text-truncate"
              data-testid="category-tag"
            >
              {categoryTag}
            </div>
          )}
          {Boolean(levelTag) && (
            <div
              className="abm-list-item-level  font-weight-700 text-truncate"
              data-testid="level-tag"
            >
              {levelTag}
            </div>
          )}
        </div>

        <div className="abm-list-item-toggle-container">
          <GenericToggle
            className="abm-toggle-container"
            leftTextClassName="toggle-left-text font-weight-700"
            rightTextClassname="toggle-right-text font-weight-700"
            rightText={itemEnabled ? t('ABM_TOGGLE_ENABLED') : t('ABM_TOGGLE_DISABLED')}
            actionFunction={changeTestgroupVisibility}
            loading={fetchLoading}
            defaultActive={itemEnabled}
          />
        </div>

        {translationEnabled && (
          <button
            className="bg-transparent border-0 outline-none mx-1"
            onClick={() =>
              showTranslateModal({
                id,
                name: nameTranslated?.[langKey] || name,
                languages,
              })
            }
            type="button"
          >
            <TranslateIcon />
          </button>
        )}

        <button
          className="bg-transparent border-0 outline-none mx-1"
          onClick={() =>
            history.push(`edit-testgroup/${id}?isScreening=${isTestgroup ? '0' : '1'}`)
          }
          type="button"
        >
          <EditPen />
        </button>
      </div>
      
      <Modal
        title={nameTranslated?.[langKey] || name}
        open={showMetricsModal}
        onCancel={() => setShowMetricsModal(false)}
        footer={null}
        width={1200}
      >
        <TestGroupMetricsDetail metrics={metrics} />
      </Modal>
    </div>
  );
};

export default ListItem;
